<template>
  <div>
    <el-dialog
      title="激活"
      @close="closeDialog"
      :visible="dialogFormVisible"
      width="600px"
      center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="机器码" prop="machineId" required>
          <el-input :disabled="!!ruleForm._id" v-model="ruleForm.machineId"></el-input>
        </el-form-item>
        <el-form-item label="激活码">
          <el-input disabled v-model="ruleForm.activationKey"></el-input>
        </el-form-item>
        <el-form-item label="机器备注" prop="machineRemark">
          <el-input v-model="ruleForm.machineRemark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['dialogFormVisible', 'keyValue'],
  data () {
    return {
      ruleForm: {
        machineId: '',
        activationKey: '',
        machineRemark: '',
        _id: ''
      },
      rules: {
        machineId: [
          { required: true, message: '请输入机器码', trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
  },
  methods: {
    closeDialog () {
      this.ruleForm = {
        _id: '',
        machineId: '',
        activationKey: '',
        machineRemark: ''
      }
      this.$emit('update:dialogFormVisible', false)
      this.$refs.ruleForm.resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.httpDispatch({})('getActivationkey', this.ruleForm).then((res) => {
            console.log(res.data)
            const { code, data } = res.data
            if (code === 0) {
              if (!data.activationKey) {
                this.$notify.error({ title: '错误', message: '激活码生成失败，请检查机器码格式', duration: 5000 })
              } else {
                this.ruleForm.activationKey = data.activationKey
                this.$emit('refresh')
              }
            }
          }).catch((err) => {
            console.log(err)
            this.$notify.error({ title: 'Error', message: `[${err.data.code}] ${err.data.msg}`, duration: 5000 })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    edit (row) {
      this.ruleForm = {
        machineId: row.machineId,
        activationKey: row.activationKey,
        machineRemark: row.machineRemark,
        _id: row._id
      }
    },
    resetForm (formName) {
      this.ruleForm = {
        machineId: '',
        activationKey: '',
        machineRemark: '',
        _id: ''
      }
      this.$refs[formName].resetFields()
    }
  }
}
</script>
